module.exports = __webpack_public_path__ + "img/home.cbde14d2.svg";